import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddOn } from '@compumark/analyst-selection-tool-client';
import { ICellRendererParams } from 'ag-grid-community';
import { WCLAddonDialogComponent } from '../wcl-addon-dialog/wcl-addon-dialog.component';

@Component({
  selector: 'app-wcl-addon-popup-link',
  standalone: false,
  templateUrl: './wcl-addon-popup-link.component.html',
  styleUrls: ['./wcl-addon-popup-link.component.scss'],
})
export class WCLAddOnPopupLinkComponent {
  addOn?: AddOn;

  constructor(private dialog: MatDialog) {}

  agInit(params: ICellRendererParams): void {
    this.addOn = params.data;
  }

  openDialog(): void {
    this.dialog.open(WCLAddonDialogComponent, {
      width: '800px',
      maxWidth: '90vw',
      autoFocus: false,
      data: {
        addOn: this.addOn,
      },
    });
  }
}
